import React, { ReactElement } from 'react';

import BlockPageContent from './BlockPageContent';
import { BlockPageContextProvider } from './BlockPageContext';
import { renderBlock } from './blocks/renderBlock';
import { BlockPageProps } from './types';

const debug = require('debug')('tca:blocks:BlockPage');

export default function BlockPage(props: BlockPageProps): ReactElement {
  return (
    <BlockPageContextProvider props={props} renderBlock={renderBlock}>
      <BlockPageContent {...props} />
    </BlockPageContextProvider>
  );
}
